<template>
  <ul id="cbt-popUp-one-one" class="">
    <li v-for="(country, index) in getCountriesWithShipping"
        :key="index"
    >
    <span class="wp_countryPikerFlagDropDown"
										:data-test="'countryPickerSpan'+index" :id="'countryPickerSpan'+index">
      <img :src="country.country_flag" alt="Country Flag"
											:data-test="'countryPickerImg'+index" :id="'countryPickerImg'+index"/>
      </span>
      <a href=""
         @click.prevent="saveChosenCountry(index)"
         class="dropdown-item"
         :id="'countryPickerNameLink'+index"
									:data-test="'countryPickerNameLink'+index"
      >
        {{country.country_name}}
      </a>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { countrySelector } from '../../../commonJs/CountrySelector'

export default {
	computed: {
		...mapGetters('siteData', ['getCountriesWithShipping'])
	},
	methods: {
		saveChosenCountry (index) {
			countrySelector.saveChosenCountry('country-select', index)
			this.$emit('closeMyRegion')
		}
	}
}
</script>
